// extracted by mini-css-extract-plugin
export default {"formInput":"ReferenceSelectorDetails_formInput__A6wmt","link":"ReferenceSelectorDetails_link__cAHRu"};